<template>
  <b-modal
    ref="mc-modal"
    size="md"
    centered
    scrollable
    :title="$t('delivery.message.cancelDeliveryTitle')"
  >
    <div class="card-body p-2">
      <p v-if="!$slots.header" v-html="defaultHeaderHtml"></p>
      <div v-else>
        <slot name="header" />
      </div>

      <p
        v-if="['Dijadwalkan', 'Dijalankan', 'Diambil'].includes(entityData.status?.name)"
        v-html="statusWillChangeAndRemoveFromFleetTaskHtml"
      ></p>

      <p v-else>
        <template v-if="isFromList">
          <span v-html="statusWillChangeAndCannotBeRestoredHtml"></span><br />
        </template>

        <template v-else>
          {{ $t('delivery.message.canceledDeliveryCannotBeRestored') }}
        </template>
      </p>

      <FormulateForm
        v-model="formValues"
        name="reason-form"
        @submit="handleSubmit"
        @failed-validation="handleFailedValidation"
      >
        <FormulateInput
          type="select-resourceful"
          name="reason-id"
          trackBy="id"
          validation="required"
          :label="$t('delivery.fields.cancelReason')"
          :placeholder="$t('delivery.placeholder.cancelReason')"
          :help="true"
          :optionLabelFn="({ item }) => item.reason"
          :optionsGetter="reasonGet"
          :validation-messages="{
            required: $t('global.validation.required'),
          }"
        />
      </FormulateForm>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton variant="secondary" :text="$t('global.back')" @click="cancel" />
        <McButton :text="$t('global.cancel')" :disabled="disabled" @click="triggerSubmit" />
      </div>
    </template>
  </b-modal>
</template>

<script>
import * as Reason from '@/services/rest-api/lib/delivery/reason'
import McButton from '@/components/McButton'

export default {
  components: {
    McButton,
  },
  props: {
    entityData: {
      required: true,
    },
    newStatusTransition: {
      required: true,
    },
    isFromList: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['transition'],
  data() {
    return {
      formValues: {},
      reasonGet: Reason.get("type eq 'CANCELED'"),
      disabled: true,
    }
  },
  computed: {
    canceledStatusLabel() {
      return this.$t(this.newStatusTransition?.status?.label) || this.$t('delivery.status.canceled')
    },
    defaultHeaderHtml() {
      return this.$t('delivery.message.confirmCancelDeliveryNumber', {
        number: this.entityData.number ? `<strong>${this.entityData.number}</strong>` : '',
      })
    },
    statusWillChangeAndRemoveFromFleetTaskHtml() {
      return this.$t('delivery.message.statusWillChangeToCanceledAndRemovedFromFleetTask', {
        status: this.canceledStatusLabel,
        fleetTaskNumber: this.entityData?.fleet_task?.number
          ? `<strong>${this.entityData.fleet_task.number}</strong>`
          : '-',
      })
    },
    statusWillChangeAndCannotBeRestoredHtml() {
      return this.$t('delivery.message.statusWillChangeToCanceledAndCannotBeRestored', {
        status: this.canceledStatusLabel,
      })
    },
  },
  watch: {
    formValues: {
      handler() {
        const reasonId = this.formValues['reason-id']

        this.disabled = reasonId === null || reasonId === undefined
      },
      deep: true,
    },
  },
  methods: {
    triggerSubmit() {
      this.$formulate.submit('reason-form')
    },
    handleSubmit(data) {
      this.$emit('transition', {
        transition: this.newStatusTransition,
        additionalPayload: {
          fields: {
            canceled_reason_id: data['reason-id'],
          },
        },
      })
    },
    handleFailedValidation(_field) {
      this.$mcToast.error(this.$t('global.inputFormatError'))
    },
    // NOTE:
    // This function will be called from parents,
    // Ideally we capitalized the first letter of the function name
    // but the name are kept as 'show' and 'hide' to match bootstrap's convention
    // of modal 'show' and 'hide' function
    show() {
      this.$refs['mc-modal'].show()
    },
    hide() {
      this.$refs['mc-modal'].hide()
    },
  },
}
</script>

<style>
.__transition-icon {
  font-size: 20px;
  vertical-align: middle;
  margin: 0 10px;

  &::before {
    color: #4a90e1;
  }
}

strong {
  font-weight: 600;
}
</style>
